import { Link } from 'react-router-dom'
import type { ExistingCompany } from '../lib/existingCompanies'

// Shown INSTEAD OF creating when the database already has a company that looks like the one being typed. The person either uses
// one of them or says, explicitly, that this is a different company. Nothing is created until they do.
interface Props {
  typedName: string
  matches: ExistingCompany[]
  busy?: boolean
  onUse?: (c: ExistingCompany) => void      // pick an existing company (forms that fill a field)
  onCreateAnyway: () => void
}

export default function ExistingCompaniesNotice({ typedName, matches, busy, onUse, onCreateAnyway }: Props) {
  return (
    <div className="mb-4 p-3 border-2 border-amber-500 bg-amber-50 dark:bg-amber-900/20 rounded-lg text-sm space-y-2" role="alert">
      <p className="font-semibold text-amber-900 dark:text-amber-200">
        A company like “{typedName}” already exists. Check before creating another one:
      </p>
      <ul className="space-y-1">
        {matches.map(m => (
          <li key={m.id} className="flex items-center justify-between gap-2">
            <span className="text-gray-900 dark:text-white">
              <span className="font-mono text-xs mr-2">{m.code}</span>{m.name}
              {!m.is_active && <span className="ml-2 text-xs text-gray-500">(inactive)</span>}
              <Link to={`/customers/${m.id}`} target="_blank" className="ml-2 text-xs text-blue-600 hover:underline">open</Link>
            </span>
            {onUse && (
              <button type="button" disabled={busy} onClick={() => onUse(m)}
                className="shrink-0 px-2 py-1 text-xs bg-blue-600 hover:bg-blue-700 text-white rounded-md font-medium disabled:opacity-50">Use this company</button>
            )}
          </li>
        ))}
      </ul>
      <button type="button" disabled={busy} onClick={onCreateAnyway}
        className="text-xs text-amber-900 dark:text-amber-200 underline disabled:opacity-50">
        None of these — it is a different company. Create “{typedName}” anyway
      </button>
    </div>
  )
}
